export default __webpack_public_path__ + "static/media/ic_my_clients_active.d4270cfb.svg";